<template><div class="d-flex justify-center">

<div style="max-width: 600px" class="pa-2">
	<component :is="WordSystems || $g.NotTranslated"/>
</div>

</div></template>

<script>

import i18n from '@/i18n'

export default {
	components: {},
	data() {
		return {

		}
	},
	methods: {

	},
	created() {

	},
	computed: {
		WordSystems() {
			return i18n.choose[this.$store.state.language].components.WordSystems || i18n.choose['en'].components.WordSystems;
		}
	}
}
</script>
